import { ANALYTICS_MESSAGES } from './utils/constants/AnalyticsConstants';
export const AdobeFormConfig = {
  //REGISTRATION
  // GetStarted
  getStartedSuccess: {
    formName: 'Get Started',
    eventType: 'registration_getStarted_success',
    formType: 'Registration',
  },
  getStartedCancel: {
    formName: 'Get Started',
    eventType: 'registration_getStarted_cancel',
    formType: 'Registration',
    formFailReason: 'User cancelled the registration',
  },
  getStartedError: {
    formName: 'Get Started',
    eventType: 'registration_getStarted_error',
    formType: 'Registration',
    formFailReason: 'Validation failure during plan selection',
  },

  // Personal Information
  personalInfoSuccess: {
    formName: 'Personal Information',
    eventType: 'registration_personalInfo_success',
    formType: 'Registration',
  },
  personalInfoCancel: {
    formName: 'Personal Information',
    eventType: 'registration_personalInfo_cancel',
    formType: 'Registration',
    formFailReason: 'User cancelled the registration',
  },
  personalInfoGuestError: {
    formName: 'Personal Information',
    eventType: 'registration_personalInfoGuest_error',
    formType: 'Registration',
  },
  personalInfoError: {
    formName: 'Personal Information',
    eventType: 'registration_personalInfo_error',
    formType: 'Registration',
  },

  // Account Setup
  accountSetupSuccess: {
    formName: 'Account Setup',
    eventType: 'registration_accountSetup_success',
    formType: 'Registration',
  },
  accountSetupCancel: {
    formName: 'Account Setup',
    eventType: 'registration_accountSetup_cancel',
    formType: 'Registration',
    formFailReason: 'User cancelled the registration',
  },
  accountSetupError: {
    formName: 'Account Setup',
    eventType: 'registration_accountSetup_error',
    formType: 'Registration',
  },
  accountSetupUsernameError: {
    formName: 'Account Setup',
    eventType: 'registration_accountSetup_username_error',
    formType: 'Registration',
  },
  accountSetupPasswordError: {
    formName: 'Account Setup',
    eventType: 'registration_accountSetup_password_error',
    formType: 'Registration',
  },

  //Communication Preferences
  communicationPreferencesSuccess: {
    formName: 'Communication Preferences',
    eventType: 'registration_communicationPreferences_success',
    formType: 'Registration',
  },
  communicationPreferencesCancel: {
    formName: 'Communication Preferences',
    eventType: 'registration_communicationPreferences_cancel',
    formType: 'Registration',
    formFailReason: 'User skipped the communication preferences',
  },

  // Activation Success
  activationSuccess: {
    formName: 'Activation Success',
    eventType: 'registration_activation_success',
    formType: 'Registration',
  },

  // FORGOT USERNAME
  forgetUsernameStep1Success: {
    formName: 'Forgot Username Step 1',
    eventType: ANALYTICS_MESSAGES.FORGOT_USERNAME_SAVE_CLICK,
    formType: 'Forgot Username',
    eventName: ANALYTICS_MESSAGES.FORGOT_USERNAME_SUCCESS,
  },
  forgetUsernameStep1Cancel: {
    formName: 'Forgot Username Step 1',
    eventType: 'forgot_username_error_step_no1_user_cancelled',
    formType: 'Forgot Username',
    eventName: ANALYTICS_MESSAGES.FORGOT_USERNAME_CANCEL,
    formFailReason: 'User cancelled the forgot username',
  },
  forgetUsernameStep1Error: {
    formName: 'Forgot Username Step 1',
    eventType: 'forgot_username_error_step_no1_service_error',
    formType: 'Forgot Username',
    eventName: ANALYTICS_MESSAGES.FORGOT_USERNAME_EXCEPTION,
  },

  // FORGOT PASSWORD
  forgotPasswordSuccess: {
    formName: 'Forgot Password',
    eventType: ANALYTICS_MESSAGES.FORGOT_PASSWORD_SUCCESS,
    formType: 'validation',
  },
  forgotPasswordCancel: {
    formName: 'Forgot Password',
    eventType: 'forgot_password_cancel',
    formType: 'validation',
    formFailReason: 'User cancelled the forgot password',
  },
  forgotPasswordError: {
    formName: 'Forgot Password',
    eventType: 'forgot_password_error',
    formType: 'validation',
    formFailReason: 'Error occurred during forgot password process',
  },
  contactUsFormSubmit: {
    formName: 'Contact Us',
    eventType: 'Contact_us_submit_click',
    formType: 'Contactus',
    formStatus: "submit"
  },
  contactUsFormSuccess: {
    formName: 'Contact Us',
    eventType: 'Contact_us_submit_success',
    formType: 'Contactus',
    formStatus: "success"
  },
};
